"use strict";
/**
 * Entry point for shared backgammon game logic.
 * Re-exports all types, constants, rules, and utilities.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.D1Utils = exports.calculatePipCount = exports.Utils = exports.Game = exports.Rules = exports.Constants = exports.API = void 0;
var tslib_1 = require("tslib");
// Export types
tslib_1.__exportStar(require("./types"), exports);
var api_1 = require("./types/api");
Object.defineProperty(exports, "API", { enumerable: true, get: function () { return api_1.API; } });
// Export constants
exports.Constants = tslib_1.__importStar(require("./constants"));
// Export game rules
exports.Rules = tslib_1.__importStar(require("./rules"));
// Export game state and board manipulation functions
exports.Game = tslib_1.__importStar(require("./game"));
// Export utilities
exports.Utils = tslib_1.__importStar(require("./utils"));
// Export frequently used utilities directly
var pipCounter_1 = require("./utils/pipCounter");
Object.defineProperty(exports, "calculatePipCount", { enumerable: true, get: function () { return pipCounter_1.calculatePipCount; } });
// Export D1 database utilities
exports.D1Utils = tslib_1.__importStar(require("./d1-utils"));
// Export game modes
tslib_1.__exportStar(require("./game-modes"), exports);
//# sourceMappingURL=index.js.map